module.exports = __webpack_public_path__ + "static/media/12.217cc6d7.jpg";